import React, { useState, useContext, useRef, useEffect } from 'react'
import { AppContext } from '../AppContext';
import { FontAwesome } from '../data/FontAwesome';
import { detectAutomaticLocation } from '../scripts/Location';

export default function Address(props) {

    const { locationSettings, updateSettings, showMsg, dol, t } = useContext(AppContext)
    const [address, setAddress] = useState(props.value)

    const updateButton = useRef(null)
    const detectButton = useRef(null)
    const searchIcon = useRef(null)
    const detectIcon = useRef(null)
    const locationSpinner = useRef(null)
    const detectSpinner = useRef(null)
    //const marker = useRef(null)

    useEffect(() => {
        setAddress(locationSettings.address)
    }, [locationSettings.address])


    function changeAddress(e) {
        setAddress(e.target.value);
    }

    function updateAddress(e) {
        e.preventDefault();
        updateButton.current.disabled = true;
        searchIcon.current.style.display = 'none';
        locationSpinner.current.style.display = 'inline-block';
        let ceCallURL = 'https://smartazanclock.com/geolocation?address=' + encodeURIComponent(address.trim());

        fetch(ceCallURL, { method: 'POST' }).then((response) => {

            if (response.status === 200) {
                response.json().then((data) => {
                    let newSettings = { locationSettings: { address: data.address, timeZoneID: data.timeZoneID, lat: data.lat, lng: data.lng } };
                    updateSettings(newSettings, t('settings.locationUpdated'));
                });
            }
            else {
                showMsg(t('settings.locationNotFound'), "error")
                setAddress(locationSettings.address)
            }
        })
            .catch(err => { showMsg(t('settings.locationOffline'), "error"); })
            .finally(() => {
                updateButton.current.disabled = false;
                searchIcon.current.style.display = 'inline-block';
                locationSpinner.current.style.display = 'none';
                document.activeElement.blur();
            });
    }


    async function detectLocation() {
        detectButton.current.disabled = true;
        detectIcon.current.style.display = 'none';
        detectSpinner.current.style.display = 'inline-block';

        try {
            const result = await detectAutomaticLocation();
            updateSettings(
                { locationSettings: result.locationSettings },
                t(result.source === 'device' ? 'settings.locationDetectedDevice' : 'settings.locationDetectedIp')
            );
        } catch (error) {
            dol(error);
            showMsg(t('settings.locationOffline'), 'error');
        } finally {
            detectButton.current.disabled = false;
            detectIcon.current.style.display = 'inline-block';
            detectSpinner.current.style.display = 'none';
            document.activeElement.blur();
        }
    }

    return (
        <form method='post' onSubmit={updateAddress} className='settings-address-form'>

            <span>{t('settings.location')}</span>

            <div className='settings-address-row'>
                <div className='flex-grow-1'>
                    <input id="address" type="text"
                        disabled={!navigator.onLine}
                        className='form-control form-control-sm settings-control' placeholder={t('settings.locationPlaceholder')} onChange={changeAddress} value={address} />
                </div>

                {
                    navigator.onLine ?
                        (
                            <>
                                <div>
                                    <button ref={updateButton} type='submit' className='btn btn-sm settings-icon-btn settings-icon-btn-primary' title={t('settings.searchLocation')}>
                                        <span ref={searchIcon}>{FontAwesome.Search}</span>
                                        <span ref={locationSpinner} className="spinner-border spinner-border-sm mx-1" style={{ display: 'none' }}></span>
                                    </button>
                                </div>
                                <div>
                                    <a target="_blank" rel="noreferrer" className='btn btn-sm settings-icon-btn settings-icon-btn-secondary' title={t('settings.mapTitle')} href={'https://maps.google.com/?q=' + locationSettings.lat + ',' + locationSettings.lng}>{FontAwesome.Google}</a>
                                </div></>) : null
                }
                {navigator.onLine ?
                    <div>
                    <button ref={detectButton} onClick={detectLocation} type='button' className='btn btn-sm settings-icon-btn settings-icon-btn-ghost' title={t('settings.detectLocation')}>
                        <span ref={detectIcon}>{FontAwesome.Reset}</span>
                        <span ref={detectSpinner} className="spinner-border spinner-border-sm mx-1" style={{ display: 'none' }}></span>
                    </button>
                    </div> : null}

            </div>
        </form>
    )
}
